import { Col, Form, Input, InputNumber, Row, Select, Slider, message, Image } from "antd";
import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import { PrimaryButtonX } from "../Components/Button3D";
import { CaretDownOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useStoreActions, useStoreState } from "../myStore";
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";
import { MediumHeaderTitle } from "../Components/Text3D";
import { neededColors } from "../helper/NeededColors";
import { fallBackImage } from "../utils/utilsFunctions";
import { Text3D } from "../Components/Text3D";

const { Option } = Select;

const MainWrapper = styled(Row)`
  .ant-row {
    row-gap: 0 !important;
  }
  .images-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 8px;
    border: 1px solid #eeeeee;
  }
`;

const ContentSection = styled(Col)`
  width: 100%;
`;
const ImgDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
`;

const FormContentDiv = styled.div``;

const InputA = styled(Input)`
  margin-top: 0.8rem;
  height: 60px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
`;
const SelectX = styled(Select)`
  margin-top: 0.5rem;
  .ant-select-selector {
    height: 60px !important;
    display: flex;
    align-items: center;
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector {
    height: 60px;
  }
  .ant-select-selection-search-input {
    height: 60px !important;
  }
`;

const formatter = (value: any) => `${value}%`;
const marks = {
  0: "1%",
  100: "100%",
};

const UploadNewQSP: FC = () => {
  const history = useHistory();
  const [infillValue, setInfillValue] = useState<any>(100);
  const [form] = Form.useForm();

  const currentItem = useStoreState((state: any) => state.cart.currentItem);
  const setCurrentItem = useStoreActions(
    (actions: any) => actions.cart.setCurrentItem
  );

  const getLocalImageUrl = (item) => {
    return URL.createObjectURL(item.designThumbnail[0].originFileObj);
  }

  const onFinish = (values: any) => {
    let items = currentItem.map((design) => {
      return {
        ...design,
        quantity: Number(values.quantity),
        scale: Number(values.scale),
        material: values.material,
        color: values.color,
        infill: infillValue,
        hasShipping: false,
      };
    });
    setCurrentItem(items);
    if (!currentItem[0].printerId) {
      history.push("/design/select");
    } else {
      history.push("/design/summary");
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      quantity: 1,
      scale: 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleMaterialChange = (material: any) => {
    if(material.toUpperCase() === 'RESIN'){
      setInfillValue(100)
    }
  }

  const handleInfillChange = (infillValue: any) => {
    const material = form.getFieldValue('material');
    if(material && material.toUpperCase() === 'RESIN') {
      setInfillValue(100);
      message.info("Resin must be printed 100% infill");
      return;
    } 
    setInfillValue(infillValue);
  }
  return (
    <>
      <MainWrapper>
        <HeaderComponent />
        <ContentSection>
          <Col span={22} offset={1}>
            <p style={{ textAlign: "center", marginTop: "1rem" }}>
              <MediumHeaderTitle dark>
                Enter your Order Details
              </MediumHeaderTitle>
            </p>
            <Row style={{ margin: "2rem 0" }}>
              <Col md={{ span: 14 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <div className="images-container">
                  {currentItem.map((singleItem) => (
                    <ImgDiv>
                      <Image
                        width={200}
                        preview={false}
                        src={
                          singleItem.uploadType === "PRIVATE"
                            ? fallBackImage
                            : !!singleItem.designId
                            ? singleItem.designThumbnail
                            : getLocalImageUrl(singleItem)
                        }
                      />
                      {singleItem.uploadType === "PRIVATE" && (
                        <>
                          <Text3D textWeight={500} textSize="0.9rem">
                            Private File
                          </Text3D>
                          <Text3D textWeight={400} textSize="0.7rem">
                            ({singleItem.files[0].name})
                          </Text3D>
                        </>
                      )}
                    </ImgDiv>
                  ))}
                </div>
              </Col>
              <Col
                md={{ span: 9, offset: 1 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <Form
                  form={form}
                  labelCol={{ span: 24 }}
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <Row gutter={[32, 32]}>
                    <Col md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                      <FormContentDiv>
                        <Form.Item
                          label="Quantity"
                          name="quantity"
                          rules={[
                            {
                              required: true,
                              message: " quantity is required!",
                            },
                          ]}
                        >
                          <InputA
                            placeholder="No of print"
                            type="number"
                            min="1"
                          />
                        </Form.Item>
                        <Form.Item
                          label="Material"
                          name="material"
                          rules={[
                            { required: true, message: "enter materials!" },
                          ]}
                        >
                          <SelectX
                            suffixIcon={<CaretDownOutlined />}
                            placeholder="Choose materials"
                            optionFilterProp="children"
                            onChange={handleMaterialChange}
                          >
                            <Option value="ABS">ABS</Option>
                            <Option value="PLA">PLA</Option>
                            <Option value="PLA_PLUS">PLA+</Option>
                            <Option value="PET">PET</Option>
                            <Option value="PETG">PETG</Option>
                            <Option value="RESIN">RESIN</Option>
                            <Option value="NYLON">NYLON</Option>
                            <Option value="NYLON_CARBON_FIBER">
                              NYLON CARBON FIBER
                            </Option>
                            <Option value="PVA">PVA</Option>
                            <Option value="TPU">TPU</Option>
                            <Option value="HIPS">HIPS</Option>
                            <Option value="SANDSTONE">SANDSTONE</Option>
                            <Option value="CERAMICS">CERAMICS</Option>
                            <Option value="STEEL">STEEL</Option>
                            <Option value="WOOD">WOOD</Option>
                            <Option value="POLYCARBONATE">POLYCARBONATE</Option>
                          </SelectX>
                        </Form.Item>
                      </FormContentDiv>
                    </Col>
                    <Col md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                      <FormContentDiv>
                        <Form.Item
                          label="Scale"
                          name="scale"
                          rules={[{ required: true, message: "enter scale!" }]}
                        >
                          <InputA
                            placeholder="Print Scale"
                            type="number"
                            // min="0"
                          />
                        </Form.Item>
                        <Form.Item
                          label="Color"
                          name="color"
                          rules={[{ required: true, message: "choose color!" }]}
                        >
                          <SelectX
                            showSearch
                            suffixIcon={<CaretDownOutlined />}
                            placeholder="Choose a Color"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option!.children as unknown as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {neededColors.map((it) => (
                              <Option value={it}>{it}</Option>
                            ))}
                          </SelectX>
                        </Form.Item>
                      </FormContentDiv>
                    </Col>
                    <Col span={24}>
                      <FormContentDiv>
                        <Form.Item label="Infill">
                          <Col
                            style={{ width: "100%", display: "flex" }}
                            span={24}
                          >
                            <Slider
                              marks={marks}
                              tipFormatter={formatter}
                              style={{ width: "75%" }}
                              min={1}
                              max={100}
                              onChange={handleInfillChange}
                              value={infillValue}
                            />
                            <InputNumber
                              min={"1%"}
                              max={"100%"}
                              style={{
                                width: "20%",
                                marginLeft: "13px",
                                height: "60%",
                              }}
                              value={`${infillValue}%`}
                              disabled
                            />
                          </Col>
                        </Form.Item>
                      </FormContentDiv>
                    </Col>
                    <div style={{ marginLeft: "1rem", width: "100%" }}>
                      <Form.Item>
                        <PrimaryButtonX
                          type="primary"
                          htmlType="submit"
                          style={{ width: "100%" }}
                        >
                          next
                        </PrimaryButtonX>
                      </Form.Item>
                    </div>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Col>
        </ContentSection>
        <FooterPublic3D />
      </MainWrapper>
    </>
  );
};
export default UploadNewQSP;
